import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCanaryIslands = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_354)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C10.5322 0 9.12605 0.264047 7.82612 0.746391L7.30435 12L7.82607 23.2536C9.12605 23.736 10.5322 24 12 24C13.4679 24 14.874 23.736 16.1739 23.2536L16.6957 12L16.1739 0.746391C14.874 0.264047 13.4679 0 12 0V0Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 6.84042 20.7435 2.44191 16.1739 0.746391V23.2537C20.7435 21.5581 24 17.1596 24 12Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82611 23.2536V0.746391C3.2565 2.44191 0 6.84042 0 12C0 17.1596 3.2565 21.5581 7.82611 23.2536Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_354",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgCanaryIslands;
